import Div from 'src/components/atomic/atom/Div'
import bg_DataBackup from 'src/assets/imgs/explorer_data_backup.png'
import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const ExplorerDeleteBackupData = () => {
  const { t } = useTranslation()
  const { setMediaStyle } = useMediaQueryHook()
  const navigate = useNavigate()
  return (
    <Div
      background_image={bg_DataBackup}
      height={setMediaStyle('108px', '164px', '87px')}
      $margin={setMediaStyle('8px 0', '8px 0', '8px 0 12px 0')}
      onClick={() => navigate('/explorer')}
    >
      <Span
        color={COLOR.brand4}
        $text_align={'left'}
        fontFamily={'NotoSansBold'}
        fontSize={setMediaStyle('30px', '49px', '25px')}
        $margin={setMediaStyle('45px 0 0 30px', '68px 0 0 45px', '35px 0 0 20px')}
      >
        {t('EXPLORER.DELETE.BACKUP_DATA', { defaultValue: 'Back up Data!' })}
      </Span>
    </Div>
  )
}
export default ExplorerDeleteBackupData
